var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, ElementRef } from '@angular/core';
import { ChartService } from "../services/chart.service";
import { ScaleResultColorService } from 'app/assessment-charts/services/scale-result-color.service';
import { BaseChartComponent } from 'app/assessment-charts/base-chart/base-chart.component';
var SummaryScalesChartComponent = /** @class */ (function (_super) {
    __extends(SummaryScalesChartComponent, _super);
    function SummaryScalesChartComponent(element, chartService, scaleResultColorService) {
        var _this = _super.call(this, element, chartService) || this;
        _this.element = element;
        _this.chartService = chartService;
        _this.scaleResultColorService = scaleResultColorService;
        _this.MAX_SCALE_NAME_LENGTH = 75;
        _this.reverseDirection = false;
        return _this;
    }
    SummaryScalesChartComponent.prototype.ngAfterViewInit = function () {
        _super.prototype.ngAfterViewInit.call(this);
    };
    SummaryScalesChartComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
    };
    SummaryScalesChartComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    SummaryScalesChartComponent.prototype.getAdjustedFontSize = function (fontSize) {
        var adjustment = fontSize / 14.4;
        var vpFontSize = this.getFontSizeForCurrentViewport();
        return fontSize * adjustment;
    };
    SummaryScalesChartComponent.prototype.getFontSizeForCurrentViewport = function () {
        var fontSize = 14.4;
        var mediumDevice = window.matchMedia('(max-width: 768px)');
        var smallDevice = window.matchMedia('(max-width: 450px');
        if (mediumDevice) {
            fontSize = 12.0;
        }
        else if (smallDevice) {
            fontSize = 10.0;
        }
        return fontSize;
    };
    SummaryScalesChartComponent.prototype.setupChartConfiguration = function () {
        var _this = this;
        var fontSize = this.getFontSizeForCurrentViewport();
        var configuration = _super.prototype.setupChartConfiguration.call(this);
        configuration.legend = {
            display: false
        };
        configuration.tooltips = {
            enabled: false
        };
        /*
        title: {
            display: false
            ,text: "some title goes here"
          }
          */
        // configuration.title = {
        //   display: true
        //   ,position: 'top'
        //   ,text: 'Severity: Slightly Elevated'
        //   ,fontSize: this.getAdjustedFontSize(18)
        // };
        var xAxes = configuration.scales.xAxes[0];
        xAxes.id = 'first-x-axis';
        xAxes.ticks = {
            beginAtZero: true,
            autoSkip: false
        };
        xAxes.gridLines = {
            offsetGridLines: true
        };
        xAxes.offset = true;
        configuration.scales.xAxes.push({
            id: 'second-x-axis',
            display: false
        });
        // configuration.scales.xAxes[0].display = false;
        // these should all be the same length so grab the first one.
        var yMax = this.scaleResults[0].scale.ranges.length;
        var yAxes = configuration.scales.yAxes[0];
        yAxes.id = 'first-y-axis';
        yAxes.type = 'linear';
        yAxes.ticks = {
            stepSize: 1,
            callback: function (value, index, values) {
                var scaleRangeNames = _this.getChartRangeNames();
                // if (value == 0 || !scaleRangeNames.hasOwnProperty(value-1)) {
                //   return " ";
                // }
                // else {
                return scaleRangeNames[value - 1];
                // }
            },
            beginAtZero: true,
            max: yMax,
            fontSize: fontSize
        };
        configuration.defaultFontSize = fontSize;
        // yAxes.padding = 0;
        // yAxes.fontSize = 10;
        yAxes.position = 'left';
        if (this.scaleResults.length < 3) {
            configuration.scales.xAxes[0].barPercentage = 0.50;
            configuration.scales.xAxes[0].maxBarThickness = 50;
        }
        else if (this.scaleResults.length < 5) {
            configuration.scales.xAxes[0].maxBarThickness = 50;
        }
        configuration.elements = {
            point: {
                radius: 0 // should hide the points from displaying...
                ,
                hoverRadius: 0
            }
        };
        configuration.scales.xAxes[0].display = this.showNames === true;
        configuration.layout.padding = {
            right: 10,
            top: 10,
            bottom: 10
        };
        return configuration;
    };
    SummaryScalesChartComponent.prototype.getLabelData = function () {
        return this._labelData;
    };
    SummaryScalesChartComponent.prototype.getDatasets = function () {
        return this._barData;
    };
    SummaryScalesChartComponent.prototype.getLabelsForScales = function (results) {
        var _this = this;
        var labels = this.scaleResults.map(function (sr) { return sr.scale.name.substring(0, Math.min(sr.scale.name.length, _this.MAX_SCALE_NAME_LENGTH)); });
        // let labels =  this.scaleResults.map(sr => sr.scale.name);
        if (this.chartScaleNames) {
            if (this.chartScaleNames.length != results.length) {
                console.error("chart scale names", this.chartScaleNames, " do not match number of scales ", results);
            }
            else {
                labels = this.chartScaleNames;
            }
        }
        // make sure we have two empty labels at the beginning and end of the graph
        // we do this because of the grid offset setting, otherwise the bar graphs would have
        // a bar at the front and end that are cut in half making the graph pretty ugly.
        // labels.unshift("");
        // labels.push("");
        return labels;
    };
    SummaryScalesChartComponent.prototype.getChartRangeNames = function () {
        var _this = this;
        var scaleRangeNames = this.chartRangeNames;
        if (!scaleRangeNames || scaleRangeNames.length == 0) {
            scaleRangeNames = this.scaleResults[0].scale.ranges.map(function (r) {
                var name = r.displayName || "";
                if (_this.showRangeScore !== false) {
                    name += " (" + r.rangeEnd + ")";
                }
                else {
                    console.log("showRangeScore was false for ", _this.scaleResults[0]);
                }
                return name;
            });
        }
        else if (scaleRangeNames.length != this.scaleResults[0].scale.ranges.length) {
            console.error("Scale range names does not match count of scale ranges");
        }
        else {
            scaleRangeNames = scaleRangeNames.map(function (v, i) {
                var range = _this.scaleResults[0].scale.ranges[i];
                return v + " (" + range.rangeEnd + ")";
            });
        }
        return scaleRangeNames;
    };
    SummaryScalesChartComponent.prototype.setupChartData = function () {
        var _this = this;
        var barColor = "#007FFF";
        var hoverBackgroundColor = "rgba(92,141,181, .75)";
        var borderColor;
        if (this.scaleResults) {
            var dataSets_1 = [];
            var barGraphData_1 = []; // to offset the bar graph by one
            // ranges where we don't have scales have to have a score range of 0...
            // need to make this just work... assume there are 5 scales...
            // scalePerc = (score > range ? rangeEnd % : score % of range)
            // 1 scale -> (score % of range), 0, 0, 0, 0
            // 2 scale -> scalePerc, 0, 0, 0, scalePerc
            // 3 scale -> scalePerc, 0, scalePerc, 0, scalePerc
            // 4 scale -> scalePerc, scalePerc, 0, scalePerc, scalePerc
            // 5 scale -> scalePerc, scalePerc, scalePerc, scalePerc, scalePerc
            // this.scaleResults.map(sr => sr.scale.ranges)
            // .reduce((prev, next) => prev = prev.concat(next), [])
            // .forEach(r => console.log(r.name, "(",r.rangeStart, "-",r.rangeEnd, ")"));
            this.scaleResults.forEach(function (sr) {
                // TODO: stephen later we want to generate an aproximate range modifier here...
                var index = sr.scale.ranges.indexOf(sr.range);
                // TODO: stephen much of this code is leftover from various graphing mechanisms we had before as each of the scales
                // is on an ordinal value, but we represent the percentage through decimal numbers here.
                var scorePercent = sr.range.getPercentageForRange(sr.score) / 100; // from 0 -> 1 this will increase the graph percent that way.
                if (scorePercent <= 0) {
                    // we need to show something on the graph so let's do a .10 percent increment here so we can see some kind of bar here.
                    scorePercent += .10;
                }
                // let index = sr.scale.ranges.indexOf(sr.range) + .5;
                barGraphData_1.push(index + scorePercent);
            });
            // barGraphData.push(0);  // to provide the padding offset at the end.
            dataSets_1.push({
                label: "data",
                backgroundColor: barColor,
                borderColor: "rgba(0, 0, 0, 1)",
                borderWidth: 1,
                yAxisID: 'first-y-axis',
                data: barGraphData_1
            });
            var scaleRangeNames_1 = this.getChartRangeNames();
            var scaleRanges = this.scaleResults[0].scale.ranges;
            var colors = this.scaleResultColorService.getBackgroundColors(scaleRangeNames_1.length);
            if (this.reverseDirection) {
                colors.reverse();
            }
            colors.forEach(function (colorChart, index) {
                dataSets_1.push({
                    label: scaleRangeNames_1[index],
                    data: Array(_this.scaleResults.length + 1).fill(index + 1),
                    backgroundColor: colorChart.color,
                    borderColor: colorChart.color
                    // ,borderWidth: 0
                    ,
                    pointRadius: 0,
                    type: 'line',
                    xAxisID: 'second-x-axis',
                    yAxisID: 'first-y-axis'
                });
            });
            this._barData = dataSets_1;
            this._labelData = this.getLabelsForScales(this.scaleResults);
        }
        else {
            this._barData = { datasets: [], label: [] };
        }
    };
    Object.defineProperty(SummaryScalesChartComponent.prototype, "hasResults", {
        get: function () {
            return this.scaleResults != null && this.scaleResults.length;
        },
        enumerable: true,
        configurable: true
    });
    return SummaryScalesChartComponent;
}(BaseChartComponent));
export { SummaryScalesChartComponent };



// WEBPACK FOOTER //
// ./src/app/assessment-charts/summary-scales-chart/summary-scales-chart.component.ts.pre-build-optimizer.js